export interface FnbSalesTransactionModel {
    TrxnOutletId: string;
    TrxnDateTime: string;
    CollectionDate: string;
    PhoneNo: string;
    EmailAddress: string;
    MemberName: string;
    MemberId: string;
    EntryPoint: string;
    IsLoggedIn: boolean;
    AppVersion: string;
    Platform: string;
    UpsellPopUp: boolean;
    Econs: string;
    Upsells: string;
}

export class FnbSalesTransaction {
    TrxnOutletId: string;
    TrxnDateTime: string;
    CollectionDate: string;
    PhoneNo: string;
    EmailAddress: string;
    MemberName: string;
    MemberId: string;
    EntryPoint: string;
    IsLoggedIn: boolean;
    AppVersion: string;
    Platform: string;
    UpsellPopUp: boolean;
    Econs: string;
    Upsells: string;

    constructor(model: FnbSalesTransaction) {
        this.TrxnOutletId = model.TrxnOutletId;
        this.TrxnDateTime = model.TrxnDateTime;
        this.CollectionDate = model.CollectionDate;
        this.PhoneNo = model.PhoneNo;
        this.EmailAddress = model.EmailAddress;
        this.MemberName = model.MemberName;
        this.MemberId = model.MemberId;
        this.EntryPoint = model.EntryPoint;
        this.IsLoggedIn = model.IsLoggedIn;
        this.AppVersion = model.AppVersion;
        this.Platform = model.Platform;
        this.UpsellPopUp = model.UpsellPopUp;
        this.Econs = model.Econs;
        this.Upsells = model.Upsells;
    }
}
